import cn from 'classnames'
import { HTMLAttributes, memo } from 'react'
import { THEME } from 'src/config/config'

import styles from './Cart.module.css'

const CartSubTitle = memo(({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(styles.cartSubTitle, className, THEME === 'legaltech' ? 'font-secondary' : 'font-primary')}
    {...props}
  >
    {children}
  </div>
))

export default CartSubTitle
